/**
 * Created by yoavp on 12/10/2014.
 * Handle is the thumb through which you open the connection panel
 *
 */

define(function (require) {
    "use strict";

    var Template = require("connection-templates/handleView.tmpl");
    var Bubble = require("ui/bubble/Bubble");


    var HandleView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        HandleView = Marionette.ItemView.extend({
            template: Template,
            className: "connection-handle",

            ui: {
                handleChatImg: ".handle-tray .handle-notifications-chat-img",
                handleChatCounter: ".handle-tray .handle-notifications-chat-counter",
                handleChatCounterNumber: ".handle-tray .handle-notifications-chat-counter .notifications-number",
                handleNotificationImg: ".handle-tray .handle-notifications-event-img",
                handleNotificationCounter: ".handle-tray .handle-notifications-event-counter",
                handleNotificationCounterNumber: ".handle-tray .handle-notifications-event-counter .notifications-number",
                handleDot: ".dot",
                handleGlobalCounterClosedTray: ".handle-notifications-global-counter-closedTray",
                handleGlobalCounterClosedTrayNumber: ".handle-notifications-global-counter-closedTray .notifications-number-closedTray"
            },
            events: {
                mouseenter: "_onMouseEnter",
                mouseleave: "_onMouseOut",
                mousedown: "_closeBubble"
            },
            modelEvents: {
                "change:chatNotificationsCounter": "_onNotificationCounterChanged",
                "change:notificationCenterEventsCounter": "_onNotificationCounterChanged",
                "change:newKPsCounter": "_onNotificationCounterChanged",
                "change:hasCriticalNotifications": "_checkCritical",
                "change:chatIsActive": "_manageHandleTray"
            },

            withUIComponents: true,

            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.listenTo(this.connectionPanelContextModel, "change:context.largeThumb", this._initiateShowing);
                this.controller = options.controller;
            },

            onShow: function () {
                this._initiateShowing();
            },

            _initiateShowing: function () {
                var skip = this.connectionPanelContextModel.get("context.largeThumb") || false;
                this.connectionPanelContextModel.set("holdHover", skip, {silent: true});
                if (skip === false) {
                    this._closeBubble();
                }
                this._closeHandle();
                if (!this._hasUserId() || skip) {
                    this._openHandle();

                    if (!this._isConnectionPanelOpen()) {
                        this.removeTooltip();
                        //need to wait till thumb animation completes only then calculate tooltip position.
                        _.delay(function (that) {
                            if (!LE.sessionManager.isExternal()) {
                                that.createBubble();
                            }
                        }, 1000, this);
                    }
                }
            },

            _hasUserId: function () {
                return !!this.connectionPanelContextModel.get("userId");
            },

            _isConnectionPanelOpen: function () {
                return this.connectionPanelContextModel.get("isOpen");
            },

            createBubble: function () {
                this.uiComponents.host$.createAndRender("registrationBubble", {
                    type: Bubble,
                    options: {
                        targetControl: this.el,
                        text: LE.translator.translate("LEConnection.unregisteredUser.handle.bubble"),
                        position: Bubble.POSITION.LEFT,
                        showCloseButton: false,
                        preventCloseOnBubbleMouseEnter: false,
                        onClick: _.bind(this._onRegistrationBubbleClick, this)
                    }
                });
            },

            removeTooltip: function () {
                this.$el.removeAttr("title");
            },

            _closeBubble: function () {
                if (this.uiComponents.registrationBubble) {
                    this.uiComponents.registrationBubble.close(true);
                }
            },

            _onNotificationCounterChanged: function () {
                var notificationCenterEventsCounter = this.model.get("notificationCenterEventsCounter");
                var chatNotificationsCounter = this.model.get("chatNotificationsCounter");
                // var newKPsCounter = this.model.get('newKPsCounter');
                var globalCounter = notificationCenterEventsCounter + chatNotificationsCounter;
                this._setGlobalNotificationCounter(globalCounter);
            },

            _setGlobalNotificationCounter: function (globalCounter) {
                var hasNotifications = globalCounter > 0;
                this.ui.handleGlobalCounterClosedTrayNumber.text(globalCounter);
                this.ui.handleGlobalCounterClosedTrayNumber.toggleClass("hide", !hasNotifications);
                this.ui.handleGlobalCounterClosedTray.toggleClass("hide", !hasNotifications);
            },

            _manageHandleTray: function (model, chatIsActive) {
                if (chatIsActive) {
                    var chatNotificationsCounter = this.model.get("chatNotificationsCounter");
                    this._toggleChatCounter((chatNotificationsCounter > 0));
                    this.$el.addClass("active");
                }
                else {
                    this.$el.removeClass("active");
                    this.model.set("chatNotificationsCounter", 0);
                }
            },

            _checkCritical: function (model, critical) {
                this.ui.handleNotificationCounterNumber.toggleClass('critical', critical);
                this.ui.handleGlobalCounterClosedTrayNumber.toggleClass('critical', critical);
            },

            //TODO unused? if so delete
            _toggleHandleTrayCounters: function (show) {
                this.$el.toggleClass('active', show);
                this._toggleChatCounter(true);
                this._toggleNotificationCounter(true);
            },

            _toggleChatCounter: function (show) {
                this.ui.handleChatCounter.toggleClass("hide", !show);
                this.ui.handleChatCounterNumber.toggleClass("hide", !show);
            },

            _toggleNotificationCounter: function (show) {
                this.ui.handleNotificationCounter.toggleClass("hide", !show);
                this.ui.handleNotificationCounterNumber.toggleClass("hide", !show);
            },

            _onMouseEnter: function () {
                if (!this.connectionPanelContextModel.get("holdHover")) {
                    this._openHandle();
                }
            },
            _onMouseOut: function () {
                if (!this.connectionPanelContextModel.get("holdHover")) {
                    this._closeHandle();
                }
            },

            /**
             * _openHandle transforms the minimized-dotted version of the thumb
             * onto the icon-based larger thumb.
             * @private
             */
            _openHandle: function () {
                this.$el.addClass("openHandle");
                this.ui.handleDot.addClass("hide");
            },

            _closeHandle: function () {
                this.$el.removeClass("openHandle");
                this.ui.handleDot.removeClass("hide");
            },

            _onRegistrationBubbleClick: function () {
                this._closeBubble();
                this.trigger("ConnectionPanel:open");
            }
        });
    });

    return HandleView;


});


